import RealtimeLayout from "#/components/realtime/RealtimeLayout";

export default function AdminAssistantVoicePage() {
  return <RealtimeLayout />;
}
